// extracted by mini-css-extract-plugin
module.exports = {"businessFlex":"Banking_businessFlex__2ZkLF","save":"Banking_save__204Mx","upperHeading":"Banking_upperHeading__djtw8"};